import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountBonus';

const AccountBonusSuspense = dynamic(() => import('./AccountBonus'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicAccountBonus(props: Props) {
	return <AccountBonusSuspense {...props} />;
}
DynamicAccountBonus.displayName = 'DynamicAccountBonus';
